<ng-container>
  <div class="error-container">
    <web-di-ld-apply-error
      [path]="path"
      [width]="width"
      title="{{ title }}"
      description="{{ description }}"
    ></web-di-ld-apply-error>

    <section class="section-card-button flex-fixed">
      <web-di-ld-button
        label="{{ buttonTitle }}"
        (click)="emitClickEvt()"
      ></web-di-ld-button>
    </section>
  </div>
</ng-container>
